import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import NaviBarv2_En from "./Components/NaviBarv2_En";
import Footer_En from "./Components/Footer_En";
import { Container, Row, Col, Card, Badge, Button, Alert } from "react-bootstrap";

const DOCS_BASE =
  (process.env.REACT_APP_API_URL || "http://localhost:8001").replace(/\/$/, "") +
  "/api/documents";
const ACCENT = "#198754";

const CARD_BODY =
  "d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center gap-3";

const numStyle = {
  width: 32,
  height: 32,
  borderRadius: "50%",
  background: ACCENT,
  color: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 14,
  marginBottom: 10,
};

const noteStyle = {
  background: "#e8f3ec",
  color: "#1b5e37",
  borderRadius: 4,
};

const RID_STEPS = [
  {
    n: 1,
    title: "Filling out the forms",
    text:
      "Fill out the required forms of the document package. For a database: Notice, Database abstract, Author consent, Personal data consent, Database structure. For software: Notice, Author consent, Personal data consent, Program code, Software abstract. Completed forms are sent by email to: denisenko.nd@talantiuspeh.ru.",
    note: "Email subject: «Пакет документов РИД — [Title]».",
  },
  {
    n: 2,
    title: "Review and examination",
    text:
      "Deadline: 10 business days. Review of the Notice, patent search, inclusion in the work plan. If required — consideration by the Scientific and Technical Committee.",
    note: "In case of errors the documents are returned for revision.",
  },
  {
    n: 3,
    title: "Approval in Tessa",
    text:
      "An «other» memo is created. Recipient: N.D. Denisenko. 7 approvers. The completed but NOT signed forms are attached.",
    note: "Edits — in editing mode only.",
  },
  {
    n: 4,
    title: "Signing",
    text:
      "Deadline: 5 business days. Signing by all authors. Scanned copies — to Tessa, originals — to the CISPT.",
    note: "Signatures are decrypted (full name + date).",
  },
  {
    n: 5,
    title: "Registration",
    text:
      "Deadline: 1 business day. Entry into the IP results register, assignment of a number, scanning, archiving.",
    note: "The IP result is considered registered and protected.",
  },
  {
    n: 6,
    title: "Preparing the IP application",
    text:
      "Deadline: 5 business days. Preparation of the package for Rospatent. Closing the memo in Tessa. Total time ~1 month.",
    note: "The application only after internal approval.",
  },
  {
    n: 7,
    title: "Assignment agreement (external authors)",
    text:
      "Deadline: 15–30 business days. Counterparty check, signing of a civil-law contract for the assignment of rights.",
    note: "Without a contract the rights do not pass to the University.",
  },
];

const RID_TEMPLATES = [
  {
    icon: "📄",
    name: "Notice of IP result creation",
    desc: "Main document — notice of the creation of an IP result",
    file: "notice.docx",
    download: "Шаблон Уведомление о создании РИД.docx",
    fmt: "Word (.docx)",
  },
  {
    icon: "📝",
    name: "Database abstract",
    desc: "Database abstract — annotation, OS, DBMS, size",
    file: "abstract-bd.docx",
    download: "Шаблон Реферат БД.docx",
    fmt: "Word (.docx)",
  },
  {
    icon: "📊",
    name: "Database structure",
    desc: "Database structure — introduction, description, references",
    file: "structure-bd.docx",
    download: "Шаблон Структура БД.docx",
    fmt: "Word (.docx)",
  },
  {
    icon: "🔐",
    name: "Personal data consent",
    desc: "Consent to personal data processing — for each author",
    file: "pd-consent.doc",
    download: "Согласие на ОПД ЭВМ БД.doc",
    fmt: "Word (.doc)",
  },
  {
    icon: "✍️",
    name: "Author consent to disclose details",
    desc: "Author consent to indicate the author's details in the application",
    file: "author-consent.doc",
    download: "Согласие автора на указание сведений об авторе.doc",
    fmt: "Word (.doc)",
  },
  {
    icon: "💻",
    name: "Program code for software",
    desc: "Fragment of the software source code",
    file: "program-code.doc",
    download: "Шаблон Код программы для ПрЭВМ.doc",
    fmt: "Word (.doc)",
  },
  {
    icon: "⚙️",
    name: "Software abstract",
    desc: "Software abstract — purpose, functions, OS, language",
    file: "abstract-program.docx",
    download: "Шаблон Реферат ПрЭВМ.docx",
    fmt: "Word (.docx)",
  },
  {
    icon: "📽️",
    name: "IP result formatting (DB) — example",
    desc: "Presentation with an example of the document package for a database",
    file: "rid-formatting-guide.pptx",
    download: "Оформление РИД БД.pptx",
    fmt: "PowerPoint (.pptx)",
  },
];

function RidRegistration_En() {
  return (
    <div className="App">
      <NaviBarv2_En />

      <Container className="py-4 text-start">
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-2">IP Result (RID) Registration</h1>
          <p className="text-muted mb-2">
            Sirius University — document package for the registration of a
            database (DB) and computer software
          </p>
          <Badge bg="success" className="fs-6 px-3 py-2">
            IP result document package
          </Badge>
        </div>

        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            Registration procedure
          </h2>
          <Row className="g-3">
            {RID_STEPS.map((s) => (
              <Col key={s.n} md={6} lg={4}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body>
                    <div style={numStyle}>{s.n}</div>
                    <h3 className="h6 fw-bold">{s.title}</h3>
                    <p className="text-muted small mb-2">{s.text}</p>
                    <div className="small px-2 py-1" style={noteStyle}>
                      {s.note}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Alert variant="warning" className="mt-3 mb-0">
            <strong>Important:</strong> Where to send:{" "}
            <strong>denisenko.nd@talantiuspeh.ru</strong>. For approval —{" "}
            <strong>UNSIGNED</strong> forms in Word.
          </Alert>
        </section>

        <section className="mb-5">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h3 className="h5 fw-bold" style={{ color: ACCENT }}>
                📋 How to work with the templates
              </h3>
              <ol className="text-muted mb-3">
                <li>
                  <strong>Download</strong> the required template by clicking the{" "}
                  <strong>«Download»</strong> button.
                </li>
                <li>
                  <strong>Open</strong> the downloaded file in Microsoft Word.
                </li>
                <li>
                  <strong>Fill in</strong> all fields with your data.
                </li>
                <li>
                  <strong>Save</strong> the completed document on your computer.
                </li>
                <li>
                  <strong>Send</strong> the completed forms by email:{" "}
                  <strong>denisenko.nd@talantiuspeh.ru</strong>.
                </li>
              </ol>
              <Alert variant="info" className="mb-0 small">
                <strong>💡 Tip:</strong> Save files using the format:{" "}
                <em>«Notice_RID_DB_[Title].docx»</em>,{" "}
                <em>«Abstract_Software_[Title].docx»</em>, etc.
              </Alert>
            </Card.Body>
          </Card>
        </section>

        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            📄 IP result package document templates
          </h2>
          <Row className="g-3">
            {RID_TEMPLATES.map((t, i) => (
              <Col key={i} md={6}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className={CARD_BODY}>
                    <div className="text-start">
                      <div className="fw-semibold">
                        {t.icon} {t.name}
                      </div>
                      <div className="text-muted small">{t.desc}</div>
                      <div className="small fw-semibold" style={{ color: ACCENT }}>
                        {t.fmt}
                      </div>
                    </div>
                    <Button
                      variant="success"
                      href={`${DOCS_BASE}/rid/${t.file}`}
                      download={t.download}
                      className="text-nowrap text-center flex-shrink-0"
                    >
                      📥 Download
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Alert variant="info" className="mt-3 mb-0 small">
            <strong>ℹ️ Note:</strong> All templates comply with the approved forms
            of Sirius University. Once completed, the forms must be signed by all
            authors and submitted for approval.
          </Alert>
        </section>
      </Container>

      <Footer_En />
    </div>
  );
}

export default RidRegistration_En;
